import type { ScheduleEditorData } from '../ScheduleEditor.types';
import { FieldMetadata } from './useScheduleFormState';

export const getFieldMetadata = (name: keyof ScheduleEditorData, metadata: Record<keyof ScheduleEditorData, FieldMetadata>) => {
  return metadata[name];
};
